"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./WithFaceDescriptor"), exports);
tslib_1.__exportStar(require("./WithFaceDetection"), exports);
tslib_1.__exportStar(require("./WithFaceExpressions"), exports);
tslib_1.__exportStar(require("./WithFaceLandmarks"), exports);
tslib_1.__exportStar(require("./WithAge"), exports);
tslib_1.__exportStar(require("./WithGender"), exports);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/face-api.js/build/commonjs/factories/index.js
 ** module id = 611
 ** module chunks = 0
 **/